import { useCollection } from "vuefire"
import {
	writeBatch,
	doc,
	setDoc,
	addDoc,
	collection,
	Timestamp,
	query,
	where,
	getCountFromServer,
	limit,
} from "firebase/firestore"

export const useEmailtemplatesStore = defineStore("emailtemplates", () => {
	const db = useFirestore()
	// const LangsStore = useLangsStore()

	const options = {
		test: {
			email: "dan.blaguiescu@gmail.com",
			email_repeat: "dan.blaguiescu@gmail.com",
			message: "Test of a message",
		},
	}

	const emailtemplates = useCollection(collection(db, "emailtemplates")).data
	const emailtemplates_defs = ref([
		{
			id: "message-from-website-en",
			subject: "Welcome to Dexterial SRL",
			html: "<div><p>Thank you for your message,</p><p>Our sales representative, Lavinia will get in contact with you soon.</p><p>Message: </p><p>{{message}}</p></div>",
			text: "Thank you for your message,\n Our sales representative, Lavinia will get in contact with you soon.\n Message: \n {{message}}",
			lang_id: "en",
			v: "0.0.0",
		},
		{
			id: "message-from-website-ro",
			subject: "Bine ai venit la Dexterial SRL",
			html: "<div><p>Va multumim pentru mesaj,</p><p> Reprezentanul nostru Lavinia va lua legatura cu dumneavoastra curand.</p><p>Mesaj: </p><p>{{message}}</p></div>",
			text: "Va multumim pentru mesaj,\n Reprezentanul nostru Lavinia va lua legatura cu dumneavoastra curand.\n Mesaj: \n {{message}}",
			lang_id: "ro",
			v: "0.0.0",
		},
		{
			id: "message-to-us-from-website-en",
			subject: "Message from website portal customer",
			html: "<div><p>Message: </p><p>{{message}}</p></div>",
			text: "Message: \n {{message}}",
			lang_id: "en",
			v: "0.0.0",
		},
		{
			id: "message-to-us-from-website-ro",
			subject: "Mesaj de la client din portalul web",
			html: "<div><p>Mesaj: </p><p>{{message}}</p></div>",
			text: "Mesaj: \n {{message}}",
			lang_id: "ro",
			v: "0.0.0",
		},
	])

	const disabled_reset_emailtemplates = ref(false)

	// const triggers_library_add = computed(() => {
	// 	const route = useRoute()
	// 	return route.path == '/libraries/all' && route.query.context == 'personal'
	// 	// return true
	// })

	async function reset() {
		disabled_reset_emailtemplates.value = true

		const db = useFirestore()
		// Get a new write batch
		const batch = writeBatch(db)

		for (const emailtemplate_entry of emailtemplates_defs.value) {
			console.log("reset emailtemplates", emailtemplate_entry)
			const emailtemplate_ref = doc(db, "emailtemplates", emailtemplate_entry.id)
			batch.set(emailtemplate_ref, emailtemplate_entry)
		}

		// Commit the batch
		await batch.commit()

		disabled_reset_emailtemplates.value = false
	}

	async function saveEmailTemplateEntry(emailtemplate_entry: tsAppendableObj) {
		// const lang_entry = langs.value.find((entry: { id: string }) => entry.id === lang_key)

		if (emailtemplate_entry) {
			disabled_reset_emailtemplates.value = true
			const db = useFirestore()
			// Get a new write batch
			// const batch = writeBatch(db)

			const data = <tsAppendableObj>{ id: emailtemplate_entry.id, subject: {}, text: {}, html: {} }
			const LangsStore = useLangsStore()
			for (const langs_id of LangsStore.langs_ids) {
				if (
					emailtemplate_entry.subject["_" + langs_id] &&
					emailtemplate_entry.subject[langs_id] != emailtemplate_entry.subject["_" + langs_id]
				) {
					data.subject[langs_id] = emailtemplate_entry.subject["_" + langs_id]
				} else {
					data.subject[langs_id] = emailtemplate_entry.subject[langs_id]
				}

				if (
					emailtemplate_entry.text["_" + langs_id] &&
					emailtemplate_entry.text[langs_id] != emailtemplate_entry.text["_" + langs_id]
				) {
					data.text[langs_id] = emailtemplate_entry.text["_" + langs_id]
				} else {
					data.text[langs_id] = emailtemplate_entry.text[langs_id]
				}

				if (
					emailtemplate_entry.html["_" + langs_id] &&
					emailtemplate_entry.html[langs_id] != emailtemplate_entry.html["_" + langs_id]
				) {
					data.html[langs_id] = emailtemplate_entry.html["_" + langs_id]
				} else {
					data.html[langs_id] = emailtemplate_entry.html[langs_id]
				}

				// const lang_ref = doc(db, 'langs', lang_entry.id)
				// batch.set(lang_ref, lang_entry)
			}
			data.v = emailtemplate_entry.v
			console.log(data)
			const db_lang_entry = doc(db, "emailtemplates", emailtemplate_entry.id)
			await setDoc(db_lang_entry, data)

			// Commit the batch
			// await batch.commit()
			disabled_reset_emailtemplates.value = false
		}
	}

	async function undoEmailTemplateEntry(emailtemplate_entry: tsAppendableObj) {
		// const lang_entry = langs.value.find((entry: { id: string }) => entry.id === lang_key)

		if (emailtemplate_entry) {
			const LangsStore = useLangsStore()
			for (const langs_id of LangsStore.langs_ids) {
				if (
					emailtemplate_entry.subject["_" + langs_id] &&
					emailtemplate_entry.subject[langs_id] != emailtemplate_entry.subject["_" + langs_id]
				) {
					emailtemplate_entry.subject["_" + langs_id] = emailtemplate_entry.subject[langs_id]
				}
				if (
					emailtemplate_entry.text["_" + langs_id] &&
					emailtemplate_entry.text[langs_id] != emailtemplate_entry.text["_" + langs_id]
				) {
					emailtemplate_entry.text["_" + langs_id] = emailtemplate_entry.text[langs_id]
				}
				if (
					emailtemplate_entry.html["_" + langs_id] &&
					emailtemplate_entry.html[langs_id] != emailtemplate_entry.html["_" + langs_id]
				) {
					emailtemplate_entry.html["_" + langs_id] = emailtemplate_entry.html[langs_id]
				}
			}
		}
	}

	const undoDisabled = computed(() => (emailtemplate_entry: tsAppendableObj) => {
		if (emailtemplates.value.length > 0) {
			// const emailtemplate_entry = emailtemplates.value.find((entry: { id: string }) => entry.id === lang_key)

			if (emailtemplate_entry) {
				const LangsStore = useLangsStore()
				for (const langs_id of LangsStore.langs_ids) {
					if (
						emailtemplate_entry.subject["_" + langs_id] &&
						emailtemplate_entry.subject[langs_id] != emailtemplate_entry.subject["_" + langs_id]
					)
						return false
					if (
						emailtemplate_entry.text["_" + langs_id] &&
						emailtemplate_entry.text[langs_id] != emailtemplate_entry.text["_" + langs_id]
					)
						return false
					if (
						emailtemplate_entry.html["_" + langs_id] &&
						emailtemplate_entry.html[langs_id] != emailtemplate_entry.html["_" + langs_id]
					)
						return false
				}
			}
		}
		return true
	})

	async function sendEmail(payload: tsAppendableObj) {
		const db = useFirestore()
		const email_obj = <tsAppendableObj>{
			to: payload.to,
			cc: payload.cc ? payload.cc : [],
			from: payload.from ? payload.from : "do_not_reply@dexterial.com",
			bcc: payload.bcc ? payload.bcc : [],
			template: {
				name: payload.template_name,
				data: payload.template_data,
			},
		}

		console.log("sendEmail", email_obj)
		sleep(3000)
		const docRef = await addDoc(collection(db, "emails"), email_obj)

		return true
	}

	async function sendEmailTemplate(template_name: string, payload: tsAppendableObj) {
		console.log("sendEmailTemplate", template_name, payload)
		const LangsStore = useLangsStore()

		// const q = query(collection(db, 'comingsoon'), where('email', '==', payload.email), limit(1))
		// const count = (await getCountFromServer(q)).data().count

		const docRef = await addDoc(collection(db, "messages"), {
			...unproxify(payload),
			...{ active: true, attempts: 0, set_date: Timestamp.now(), lang_id: LangsStore.context.lang_id },
		})
		// console.log(
		// 	"setInterest",
		// 	"not found, set it up add ref",
		// 	{
		// 		...event.data,
		// 		...{ active: true, attempts: 0, set_date: Timestamp.now(), lang_id: LangsStore.context.lang_id },
		// 	},
		// 	docRef.id,
		// )
		const url = useRequestURL()
		if (docRef && docRef.id) {
			// 	console.log("setInterest", "not found, set it up send email", {
			// 		to: [event.data.email],
			// 		template_name: "coming-soon-welcome-" + LangsStore.context.lang_id,
			// 		template_data: { uid: docRef.id, _base_link: url.protocol + "//" + url.host },
			// 	})

			return await sendEmail({
				to: [payload.email],
				from: "do_not_reply@dexterial.com",
				template_name: template_name + "-" + LangsStore.context.lang_id,
				template_data: { ...{ uid: docRef.id, _base_link: url.protocol + "//" + url.host }, ...unproxify(payload) },
			})
		}
		return false
	}
	return {
		emailtemplates,
		options,
		disabled_reset_emailtemplates,
		sendEmail,
		sendEmailTemplate,
		reset,
		saveEmailTemplateEntry,
		undoEmailTemplateEntry,
		// saveLangEntry,
		// undoLangEntry,
		undoDisabled,
		// getStructure,
	}
})

// if (import.meta.hot) {
// 	import.meta.hot.accept(acceptHMRUpdate(useEmailtemplatesStore, import.meta.hot))
// }
